import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserUtils } from '@azure/msal-browser';
import { MsalGuard } from '@azure/msal-angular';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { AdminComponent } from './admin/admin.component';
import { AdminEventsComponent } from './admin-events/admin-events.component';
import { MyRequestsComponent } from './my-requests/my-requests.component';
import { EventRequestComponent } from './event-request/event-request.component';
import { HealthComponent } from './health/health.component';
import { BlockedUsersComponent } from './blocked-users/blocked-users.component';


const routes: Routes = [
  { path: 'calendar', canActivate: [MsalGuard], component: DashboardComponent },
  { path: 'request', canActivate: [MsalGuard], component: EventRequestComponent },
  { path: 'profile', canActivate: [MsalGuard], component: ProfileComponent },
  { path: 'admin', canActivate: [MsalGuard], component: AdminComponent },
  { path: 'admin-events', canActivate: [MsalGuard], component: AdminEventsComponent },
  { path: 'blocked-users', canActivate: [MsalGuard], component: BlockedUsersComponent },
  { path: 'my-requests', canActivate: [MsalGuard], component: MyRequestsComponent },
  { path: 'health', canActivate: [MsalGuard], component: HealthComponent },
  { path: '', redirectTo: '/calendar', pathMatch: 'full'},
  { path: '**', redirectTo: '/calendar'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, 
    {
      useHash: true,
      onSameUrlNavigation: 'reload',
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled'
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }